module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "liveanser"
  }, [(_vm.isAnsering) ? _c('div', {
    staticClass: "liveanserContent"
  }, [_c('div', {
    staticClass: "liveanser-top"
  }, [_c('span', {
    staticStyle: {
      "font-size": "16px"
    }
  }, [_vm._v(_vm._s(_vm.titTypeObj[_vm.question.type]))]), _vm._v(" "), (this.question.second != 0) ? _c('div', {
    staticStyle: {
      "display": "flex",
      "align-items": "center"
    }
  }, [_c('img', {
    staticClass: "liveanser-top-timeicon",
    attrs: {
      "src": require("../../../statics/imgs/answer/answer_time_icon@2x.png")
    }
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "margin-left": "6px",
      "color": "#202020",
      "font-size": "16px"
    }
  }, [_vm._v(_vm._s(_vm.timeoutStr))])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "liveanser-middle"
  }, [_c('div', {
    staticStyle: {
      "font-size": "14px",
      "color": "#202020",
      "line-height": "22px",
      "word-break": "break-all"
    }
  }, [_vm._v(_vm._s(_vm.question.title))]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "20px"
    }
  }, [(_vm.question.type != 4) ? _vm._l((_vm.AnSerOption), function(item, index) {
    return _c('div', {
      staticStyle: {
        "margin-bottom": "14px",
        "display": "flex",
        "align-items": "center"
      },
      on: {
        "click": function($event) {
          return _vm.anserSelect(item, index)
        }
      }
    }, [_c('img', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (item.select),
        expression: "item.select"
      }],
      staticStyle: {
        "width": "18px",
        "height": "18px"
      },
      attrs: {
        "src": require("../../../statics/imgs/answer/anser_sel.png")
      }
    }), _vm._v(" "), _c('img', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (!item.select),
        expression: "!item.select"
      }],
      staticStyle: {
        "width": "18px",
        "height": "18px"
      },
      attrs: {
        "src": require("../../../statics/imgs/answer/anwser_unsel.png")
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "ansercontent"
    }, [_vm._v(_vm._s(item.key) + "." + _vm._s(item.content))])])
  }) : _vm._e(), _vm._v(" "), (_vm.question.type == 4) ? _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.userTextAnswer),
      expression: "userTextAnswer"
    }],
    staticClass: "anserTextA",
    attrs: {
      "placeholder": "请输入内容"
    },
    domProps: {
      "value": (_vm.userTextAnswer)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.userTextAnswer = $event.target.value
      }
    }
  }) : _vm._e()], 2), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "right",
      "margin-top": "16px"
    }
  }, [_c('div', {
    staticClass: "liveanserbtn",
    on: {
      "click": _vm.commitAnserTap
    }
  }, [_vm._v("提交")])])])]) : _vm._e(), _vm._v(" "), (!_vm.isAnsering && _vm.isSatus != 3) ? _c('div', {
    staticClass: "anserSccussContent"
  }, [_c('div', {
    staticClass: "anserSccussContentBg"
  }), _vm._v(" "), (_vm.isSatus == 1) ? _c('img', {
    staticClass: "anserSccussImg",
    attrs: {
      "src": require("../../../statics/imgs/answer/answer_success_icon@2x.png")
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isSatus == 2) ? _c('img', {
    staticClass: "anserSccussImg",
    attrs: {
      "src": require("../../../statics/imgs/answer/answer_error_icon@2x.png")
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "anserSccussText"
  }, [_vm._v(" " + _vm._s(_vm.isSatus == 1 ? "恭喜你，回答正确" : "很遗憾，回答错误"))]), _vm._v(" "), _c('div', {
    staticClass: "anserSccussBtn",
    on: {
      "click": _vm.ikonwnTap
    }
  }, [_vm._v(_vm._s(_vm.isSatus == 1 ? "我知道啦" : "再接再历"))])]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2ba35adc"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Modular/liveanser.vue
// module id = 411
// module chunks = 0